import type { ResidentReportModel } from "../types/resident-report.types";
import { formatReportMonth } from "../utils/report-formatters";

export function RecentEngagement({ recentEngagement }: Pick<ResidentReportModel, "recentEngagement">) {
  return (
    <section className="report-card recent-engagement">
      <header>
        <div>
          <p className="report-eyebrow">Timeline</p>
          <h2>Recent engagement</h2>
        </div>
      </header>
      {recentEngagement.length === 0 ? (
        <p className="report-empty-state">No recent engagement recorded.</p>
      ) : (
        <ol>
          {recentEngagement.map((entry) => (
            <li key={entry.id} className={entry.isCurrent ? "is-current" : ""}>
              <time>{formatReportMonth(entry.date)}</time>
              <div>
                <strong>{entry.title}</strong>
                {entry.description ? <span>{entry.description}</span> : null}
              </div>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
